import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import CategoryPage from "@/pages/CategoryPage";
import SeoPage from "@/pages/SeoPage";
import SmoothScroll from "@/components/SmoothScroll";
import { Toaster } from "sonner";

const CATEGORY_SLUGS = [
  "pieces-auto",
  "moteurs",
  "boites-de-vitesses",
  "calculateurs",
  "blocs-abs",
  "calculateurs-moteur",
  "pieces-electroniques",
];

const SEO_SLUGS = [
  "moteurs-occasion-guadeloupe",
  "boites-vitesses-guadeloupe",
  "pieces-auto-occasion-guadeloupe",
  "moteur-puretech-guadeloupe",
  "calculateurs-auto-guadeloupe",
  "blocs-abs-guadeloupe",
  "turbos-guadeloupe",
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            {CATEGORY_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<CategoryPage />} />
            ))}
            {SEO_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<SeoPage />} />
            ))}
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="top-center"
        toastOptions={{
          style: { background: "#fff", border: "1px solid #e5e5e3", color: "#0a0a0a", fontFamily: "Manrope, sans-serif" },
        }}
      />
    </div>
  );
}

export default App;
